import React from "react";
import { MultiAskAIChatbot } from "@root/components/MultiAskAIChatbot/MultiAskAIChatbot";

const MultiAskAIPage: React.FC = () => {
  return <MultiAskAIChatbot />;
};

export default MultiAskAIPage;
